import { useTranslation } from "react-i18next";
import MenuWithDrawer from "../../components/app/layout/menuWithDrawer/menuWithDrawer";
import useMenuAction from "../../hooks/menu/useMenuAction";
import { NAVIGATION } from "../../locales/components/namespaces";
import ContentRouter from "../../routers/contentRouter.jsx";

const Content = () => {
	const { t, i18n } = useTranslation(NAVIGATION)
	const { setMenuItems, setMenuActiveItem } = useMenuAction()
	return (
		<MenuWithDrawer>
			<ContentRouter/>
		</MenuWithDrawer>
	)
}

export default Content;
